// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3awZQ","largestCol":"styles_largestCol__2GX8R","smallestCol":"styles_smallestCol__1Epbx"};